import disneyOneIdWrapper from 'disneyOneIdWrapper'; //eslint-disable-line import/no-unresolved, import/extensions
import { addVisitorTrackingIDs, omnitureClickTrack } from './tracking-suite/click-tracking';

export function openUrl({ loginSuccessUrl, target, href, onclick }) {
    // eslint-disable-next-line no-script-url
    const isValidHref = href && (href !== 'javascript:;');

    if (onclick) {
        onclick();
    } else if (target === '_blank' && isValidHref) {
        window.open(href, target);
    } else {
        window.location = loginSuccessUrl || href;
    }
}

export function addClickHandlerToButtons() {
    const $pageView = $('.page-content-visible');
    const allButtons = $pageView.find('.cta-button, a');

    allButtons.each((index, button) => {
        // eslint-disable-next-line prefer-arrow-callback
        button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const {
                loginSuccessUrl,
                oneidScript,
                addExternalTracking
            } = button.dataset;

            const { target, onclick } = button;
            let { href } = button;
            window.disneyIDLoginSuccessUrl = loginSuccessUrl;

            if (addExternalTracking) {
                button = addVisitorTrackingIDs(button);
                href = button.href;
            }

            const handleRedirect = function () {
                openUrl({ loginSuccessUrl, target, href, onclick });
            };
            const validOneIdScript = oneidScript && disneyOneIdWrapper.disneyIdService[oneidScript];
            const shouldCallOneID = validOneIdScript && !window.isLoggedIn;
            const action = shouldCallOneID ? validOneIdScript : handleRedirect;

            const result = omnitureClickTrack.call(button);

            /**
             * If the user clicks a link and it opens in a new window (e.g terms) and we wait for
             * the Omniture promise to resolve, Firefox thinks that this is a popup and blocks it.
             * If the target is _blank and we are not calling a oneidScript, then immediately send
             * the user to the desired link.
             *
             **/

            if (target === '_blank' && !shouldCallOneID) {
                handleRedirect();
            } else {
                result.then(action);
            }

            result.catch((error) => {
                console.error(error);
                handleRedirect();
            });
        });
    });
}
